function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7ff9704f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!../../../node_modules/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./DynamicPetition.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!../../../node_modules/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./DynamicPetition.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7ff9704f\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!../../../node_modules/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./DynamicPetition.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ff9704f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dynamic-petition/DynamicPetition.vue
// module id = 272
// module chunks = 0